import React from "react";
import Select from "react-select";
import "./filters.css";

const Radio = ({
  filterName,
  options = [],
  placeholder = "Select Option",
  value,
  onChange,
}) => {
  const selectedOption =
    options.find((option) => option.value === value) || null;

  return (
    <Select
      options={options}
      value={selectedOption}
      placeholder={placeholder}
      classNamePrefix="royal-select"
      className="royal-select-container"
      isClearable
      onChange={(selectedOption) =>
        onChange?.(filterName, selectedOption?.value || "")
      }
    />
  );
};

export default Radio;
